import { Link, NavLink, useLocation } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { useAuth } from "@/lib/auth";

const links = [
  { to: "/", label: "Home" },
  { to: "/directory", label: "Directory" },
  { to: "/showcase", label: "How I Save £220/mo" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const loc = useLocation();

  return (
    <header className="mds-nav" data-testid="site-header">
      <div className="mds-container flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2" data-testid="brand-link" onClick={() => setOpen(false)}>
          <img
            src="/logo.webp"
            alt="Matt's Daily Savers"
            className="h-11 sm:h-12 w-auto"
            width="48"
            height="48"
          />
          <span className="sr-only">Matt's Daily Savers</span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-${l.to.replace(/\//g, "") || "home"}`}
              className={({ isActive }) =>
                `px-3 py-2 rounded-lg text-sm transition-colors ${
                  isActive
                    ? "text-[#1C2321] bg-[#F0EFEA]"
                    : "text-[#4A5D54] hover:text-[#1C2321] hover:bg-[#F0EFEA]/60"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          {user && user.role === "admin" ? (
            <Link to="/admin/dashboard" data-testid="nav-admin" className="ml-2 mds-btn mds-btn-primary text-sm py-2 px-3">
              Admin
            </Link>
          ) : (
            <Link to="/admin" data-testid="nav-admin-login" className="ml-2 mds-btn mds-btn-secondary text-sm py-2 px-3">
              Admin
            </Link>
          )}
        </nav>

        <button
          className="md:hidden mds-btn mds-btn-ghost p-2"
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#E5E3DB] bg-[#F9F8F6]" data-testid="mobile-menu">
          <div className="mds-container py-3 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.to.replace(/\//g, "") || "home"}`}
                className={({ isActive }) =>
                  `px-3 py-3 rounded-lg text-base ${
                    isActive ? "bg-[#F0EFEA] text-[#1C2321]" : "text-[#4A5D54]"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to={user && user.role === "admin" ? "/admin/dashboard" : "/admin"}
              onClick={() => setOpen(false)}
              className="mds-btn mds-btn-primary mt-2"
              data-testid="mobile-nav-admin"
            >
              {user && user.role === "admin" ? "Admin Dashboard" : "Admin Login"}
            </Link>
          </div>
        </div>
      )}
      {/* keep location refs happy for lint */}
      <span className="hidden" data-path={loc.pathname} />
    </header>
  );
}
